import { ReactElement, useState } from "react";
import { useNavigate } from "react-router";
import { Button } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "~/components/modal/Dialog";
import { BUYER } from "~/constants/routes";
import { BusinessFormCreate } from "~/forms/business/BusinessFormCreate";
import { CreateConnectionContent } from "./CreateConnectionContent";

const CreateBuyerDialogPages = {
  CREATE_BUYER: 0,
  CREATE_CONNECTION: 1,
} as const;

type CreateBuyerDialogState =
  | { step: typeof CreateBuyerDialogPages.CREATE_BUYER }
  | {
      step: typeof CreateBuyerDialogPages.CREATE_CONNECTION;
      buyerId: number;
      email: string;
      deliveryInstructions?: string;
    };

export function CreateBuyerDialog({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}): ReactElement {
  const [state, setState] = useState<CreateBuyerDialogState>({
    step: CreateBuyerDialogPages.CREATE_BUYER,
  });
  const navigate = useNavigate();

  return (
    <Dialog active={active} initPage={CreateBuyerDialogPages.CREATE_BUYER}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={() => {
          if (state.step === CreateBuyerDialogPages.CREATE_CONNECTION) {
            navigate(BUYER.href({ buyerId: state.buyerId }));
          }
          onDismiss();
        }}
        title={"Add customer"}
      />
      <DialogContent>
        {state.step === CreateBuyerDialogPages.CREATE_BUYER && (
          <BusinessFormCreate
            mode="supplier-customer"
            type={"buyer"}
            formId="create-buyer-form"
            onCreate={({ business, deliveryInstructions }) => {
              if (!business.Retailer?.id || !business.email) {
                throw new Error("Created buyer details are missing");
              }

              setState({
                step: CreateBuyerDialogPages.CREATE_CONNECTION,
                buyerId: business.Retailer.id,
                email: business.email,
                deliveryInstructions,
              });
            }}
            metadata={{
              createdFrom: "Add customer",
              initiator: "supplier",
            }}
          />
        )}
        {state.step === CreateBuyerDialogPages.CREATE_CONNECTION && (
          <CreateConnectionContent
            buyerId={state.buyerId}
            email={state.email}
            deliveryInstructions={state.deliveryInstructions}
          />
        )}
      </DialogContent>
      {state.step === CreateBuyerDialogPages.CREATE_BUYER && (
        <DialogCTA>
          <Button type="submit" form="create-buyer-form">
            Next
          </Button>
        </DialogCTA>
      )}
    </Dialog>
  );
}
